// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1tM5q","header":"PatientQuestionnaire_header__1OzR-","info":"PatientQuestionnaire_info__1fonm"};